import React from "react"

const ArrowBottom = props => {
  return (
    <svg
      height='25'
      width='24'
      fill='none'
      viewBox='0 0 24 25'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M11.8389 15.4596L6.90601 10.5514H16.7717L11.8389 15.4596Z'
        fill='#131212'
      />
    </svg>
  )
}

export default ArrowBottom
